import { default as join } from './join/services'
import { default as category } from  './category/services'

export default {
    ...join,
    ...category,
}